// Printf for JS
String.prototype.printf = function() { // eslint-disable-line no-extend-native
    let formatted = this;
    /* eslint-disable guard-for-in */
    for ( let arg in arguments ) { // eslint-disable-line prefer-rest-params
        let beforeFormatted = formatted.substring(0, formatted.indexOf('%s', 0));
        let afterFormatted = formatted.substring(formatted.indexOf('%s', 0)+2, formatted.length);
        formatted = beforeFormatted + arguments[arg] + afterFormatted; // eslint-disable-line prefer-rest-params
    }
    return formatted;
};

/**
 * Switching tabs
 *
 * @param {object} tab
 * @param {object} params
 */
function spbcSwitchTab(tab, params) {
    let tabName = tab.classList[1].replace('spbc_tab_nav-', '');

    // update url
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set('spbc_tab', tabName);
    let hashParam = window.location.hash;
    let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hashParam;

    history.replaceState(null, '', newRelativePathQuery);

    // Hiding a tab 'Backups' if exist
    if (searchParams.get('spbc_tab') !== 'backups') {
        jQuery('.spbc_tab_nav-backups').hide();
    }

    // update active tab
    jQuery('.spbc_tab_nav').removeClass('spbc_tab_nav--active');
    jQuery('.spbc_tab').removeClass('spbc_tab--active');
    jQuery(tab).addClass('spbc_tab_nav--active');
    jQuery('.spbc_tab-' + tabName).addClass('spbc_tab--active');

    if (!jQuery(tab).data('loaded')) {
        let data = {
            action: 'spbc_settings__draw_elements',
            tab_name: tabName,
            security: spbcSettings.ajax_nonce,
        };
        params = {
            callback: spbcDrawSettingsCallback,
            notJson: true,
            additional: params || null,
        };
        spbcSendAJAXRequest( data, params, tab );
    } else if (params && params.action) {
        switch (params.action) {
        case 'highlight':
            spbcHighlightElement(params.target, params.times);
            break;
        case 'click':
            setTimeout(function() {
                jQuery('#'+params.additional.target).click();
            }, 500);
            break;
        }
    }
}

/**
 * Draws settings
 *
 * @param {*} result
 * @param {*} data
 * @param {*} params
 * @param {*} obj
 */
function spbcDrawSettingsCallback(result, data, params, obj) {
    jQuery(obj).data('loaded', true);
    jQuery('.spbc_tab-'+data.tab_name).replaceWith(result);
    let tab = jQuery('.spbc_tab-'+data.tab_name);
    tab.addClass('spbc_tab--active');

    jQuery(document).off( 'click', '.spbc_long_recommendation__show');
    jQuery(document).on('click', '.spbc_long_recommendation__show', function() {
        self = jQuery(this);
        spbcSettingsShowRecommendation(self, self.attr('data-setting') || self.attr('setting'));
    });

    if (params.additional) {
        switch (params.additional.action) {
        case 'highlight':
            spbcHighlightElement(params.additional.target, params.additional.times);
            break;
        case 'click':
            setTimeout(function() {
                jQuery('#'+params.additional.target).click();
            }, 500);
            break;
        }
    }

    jQuery(tab).on('click', '.spbc_hint-send_'+data.tab_name, function() {
        jQuery('.spbc_hint-send_'+data.tab_name).hide();
        spbcSendAJAXRequest(
            {action: 'spbc_send_'+data.tab_name, tab_name: data.tab_name},
            {callback: spbcSendLogsCallback},
        );
    });

    // scroll to anchor
    if (window.location.hash) {
        let scrollToTag = document.getElementById(window.location.hash.substring(1));
        if (scrollToTag !== null) {
            scrollToTag.scrollIntoView();
        }
    }

    if (typeof spbcHighlightCriticalFilesNotice === 'function') {
        spbcHighlightCriticalFilesNotice(false);
    }

    spbcSaveSettingsButtonMobileLayout();
    window.addEventListener('resize', (event) => {
        spbcSaveSettingsButtonMobileLayout();
    });
}

/**
 * A chunk to hide the custom element "submit button" on large screen or make sticky on mobile
 */
function spbcSaveSettingsButtonMobileLayout() {
    const selector = document.querySelector('div[name="spbc_settings--save_button_custom"]');
    if (selector) {
        if (window.innerWidth > 900) {
            selector.style.display = 'none';
        } else {
            selector.style.display = 'flex';
        }
    }
}

/**
 * Sends logs
 *
 * @param {*} result
 * @param {*} data
 * @param {*} params
 * @param {*} obj
 */
function spbcSendLogsCallback(result, data, params, obj) {
    jQuery('.spbc_tab_nav-'+data.tab_name).data('loaded', false);
    spbcSwitchTab(document.getElementsByClassName('spbc_tab_nav-'+data.tab_name)[0]);
}

/**
 * Disables/enables settings by ID
 *
 * @param {array} settingsIDs
 * @param {number} enable
 */
function spbcSettingsDependenciesbyId(settingsIDs, enable) { // eslint-disable-line no-unused-vars
    if (typeof settingsIDs === 'string') {
        tmp = [];
        tmp.push(settingsIDs);
        settingsIDs = tmp;
    }

    enable = typeof enable === 'undefined' ? null : +enable;

    settingsIDs.forEach(function(settingID, i, arr) {
        let elem = document.getElementById('spbc_setting_'+settingID);
        let doDisable = function() {
            elem.setAttribute('disabled', 'disabled');
        };
        let doEnable = function() {
            elem.removeAttribute('disabled');
        };

        if (enable !== null) {
            // Set
            enable === 1 ? doEnable() : doDisable();
        } else {
            // Switch
            elem.getAttribute('disabled') === null ? doDisable() : doEnable();
        }
    });
}

/**
 * Recursive in case children found!
 *
 * Settings dependencies
 *
 * @param {array} settingNames
 * @param {number} enable
 */
function spbcSettingsDependencies(settingNames, enable) { // eslint-disable-line no-unused-vars
    // Cast settingNames to array
    const eventTarget = window.event && window.event.target ? window.event.target : null;
    const isRadio = eventTarget && eventTarget.type === 'radio';
    const radioEnabled = isRadio && eventTarget.value == '1';
    const targetEnableFlag = eventTarget ?
        ((isRadio && !radioEnabled) || +eventTarget.checked) :
        null;
    const doEnableFlag = typeof enable === 'undefined' ? targetEnableFlag : +enable;

    settingNames = typeof settingNames === 'string' ? settingNames.split(',') : settingNames;

    settingNames.forEach(function(settingName, i, arr) {
        let elements = document.getElementsByName('spbc_settings['+settingName+']');
        if (elements.length === 0) {
            // multiple selector case
            elements = document.getElementsByName('spbc_settings['+settingName+'][]');
        }

        elements
            .forEach(function( elem, i, arr ) {
                let doDisable = function() {
                    elem.setAttribute('disabled', 'disabled');
                };
                let doEnable = function() {
                    elem.removeAttribute('disabled');
                };
                if (doEnableFlag !== null) {
                    // Set
                    doEnableFlag === 1 ? doEnable() : doDisable();
                } else {
                    // Switch
                    elem.getAttribute('disabled') === null ? doDisable() : doEnable();
                }

                let children = elem.getAttribute('data-children');
                if ( children !== null ) {
                    spbcSettingsDependencies(children, doEnableFlag && elem.checked);
                }
            });
    });
}

/**
 * Shows recommendation
 *
 * @param {object} label
 * @param {string} settingId
 */
function spbcSettingsShowRecommendation(label, settingId) {
    let removeRecommendationFunc = function(e) {
        if (
            typeof e === 'undefined' ||
            (
                jQuery(e.target).parent('.spbc_long_desc').length == 0 ||
                jQuery(e.target).hasClass('spbc_long_desc__cancel')
            ) && !jQuery(e.target).hasClass('spbc_long_recommendation__show')
        ) {
            jQuery('.spbc_long_desc').remove();
            jQuery(document).off('click', removeRecommendationFunc);
        }
    };

    removeRecommendationFunc();

    label.after('<div id=\'spbc_long_desc__'+settingId+'\' class=\'spbc_long_desc\'></div>');
    let obj = jQuery('#spbc_long_desc__'+settingId);
    obj.append('<i class=\'spbc-icon-spin1 animate-spin\'></i>')
        .append('<div class=\'spbc_long_desc__angle_top_left\'></div>')
        .css({
            top: label.position().top + 25,
            left: label.position().left + 5,
        });


    spbcSendAJAXRequest(
        {action: 'spbc_settings__get_recommendation', setting_id: settingId},
        {
            spinner: obj.children('img'),
            callback: function(result, data, params, obj) {
                obj.empty()
                    .append('<div class=\'spbc_long_desc__angle_top_left\'></div>')
                    .append('<i class=\'spbc_long_desc__cancel spbc-icon-cancel\'></i>')
                    .append('<h3 class=\'spbc_long_desc__title\' style=\'margin-right: 2em;\'>'+result.title+'</h3>')
                    .append('<p>'+result.desc+'</p>');

                jQuery(document).on('click', removeRecommendationFunc);
            },
        },
        obj,
    );
}

/**
 * Shows/hides full text
 */
function spbcStartShowHide() { // eslint-disable-line no-unused-vars
    jQuery('.spbcShortText')
        .off('mouseover' )
        .on('mouseover', function() {
            jQuery(this).next().show();
        })
        .off('mouseout' )
        .on('mouseout', function() {
            jQuery(this).next().hide();
        });
    jQuery('.spbcFullText')
        .off('mouseout' )
        .on('mouseout', function() {
            jQuery(this).hide();
        })
        .off('mouseover' )
        .on('mouseover', function() {
            jQuery(this).show();
        });
}

/**
 * Reloads last scan info
 */
function spbcScannerReloadScanInfo() { // eslint-disable-line no-unused-vars
    jQuery('.spbc_hint__last_scan_title').text(spbcScaner.look_below_for_scan_res);
    const data = {
        action: 'spbc_scanner__last_scan_info',
    };
    const params = {
        callback: (result) => {
            document.getElementById('spbc_scanner__last_scan_info').innerText = result.data;
        },
    };
    spbcSendAJAXRequest(data, params);
}

/**
 * Checking current account status for renew notice
 */
function spbcBannerCheck() {
    let bannerChecker = setInterval( function() {
        spbcSendAJAXRequest(
            {action: 'spbc_settings__check_renew_banner'},
            {
                callback: function(result, data, params, obj) {
                    if (result.close_renew_banner) {
                        if (jQuery('#spbc_renew_notice').length) {
                            jQuery('#spbc_renew_notice').hide('slow');
                        }
                        if (jQuery('#spbc_trial_notice').length) {
                            jQuery('#spbc_trial_notice').hide('slow');
                        }
                        clearInterval(bannerChecker);
                    }
                },
            },
        );
    }, 60000);
}

jQuery(document).ready(function() {
    if (jQuery('#spbc_renew_notice').length || jQuery('#spbc_trial_notice').length) {
        spbcBannerCheck();
    }

    // Sync button migrated to react

    if ( spbcSettings.key_changed ) {
        jQuery('#spbc_button__sync').click();
    }

    // Get Key Auto button migrated to Signup Wizard

    // Import settings
    jQuery( document ).on('click', '#spbc_settings_templates_import_button', function() {
        jQuery('#spbc-ajax-result').remove();
        let optionSelected = jQuery('option:selected', jQuery('#spbc_settings_templates_import'));
        let templateNameInput = jQuery('#spbc_settings_templates_import_name');
        templateNameInput.css('border-color', 'inherit');
        if ( typeof optionSelected.data('id') === 'undefined' ) {
            console.log( 'Attribute "data-id" not set for the option.' );
            return;
        }
        let data = {
            'template_id': optionSelected.data('id'),
            'template_name': optionSelected.data('name'),
            'settings': optionSelected.data('settings'),
        };
        let button = this;
        spbcSendAJAXRequest(
            {action: 'spbc_settings_templates_import', data: data},
            {
                timeout: 25000,
                button: button,
                spinner: jQuery('#spbc_settings_templates_import_button .spbc_preloader_button' ),
                callback: function(result, data, params, obj) {
                    let selector;
                    if (result.success) {
                        selector = '<p id=\'spbc-ajax-result\' class=\'success\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                        jQuery('#spbc_settings_templates_import_button .spbc_success').show(300);
                        setTimeout(function() {
                            jQuery('#spbc_settings_templates_import_button .spbc_success').hide(300);
                        }, 2000);
                        document.addEventListener('spbcModalClosed', function( e ) {
                            document.location.reload();
                        });
                        setTimeout(function() {
                            spbcModal.close();
                        }, 2000);
                    } else {
                        selector = '<p id=\'spbc-ajax-result\' class=\'error\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                    }
                },
            },
        );
    });

    // Export settings
    jQuery( document ).on('click', '#spbc_settings_templates_export_button', function() {
        jQuery('#spbc-ajax-result').remove();
        let optionSelected = jQuery('option:selected', jQuery('#spbc_settings_templates_export'));
        let templateNameInput = jQuery('#spbc_settings_templates_export_name');
        templateNameInput.css('border-color', 'inherit');
        if ( typeof optionSelected.data('id') === 'undefined' ) {
            console.log( 'Attribute "data-id" not set for the option.' );
            return;
        }
        let data;
        if ( optionSelected.data('id') === 'new_template' ) {
            let templateName = templateNameInput.val();
            if ( templateName === '' ) {
                templateNameInput.css('border-color', 'red');
                return;
            }
            data = {
                'template_name': templateName,
            };
        } else {
            data = {
                'template_id': optionSelected.data('id'),
            };
        }
        let button = this;
        spbcSendAJAXRequest(
            {action: 'spbc_settings_templates_export', data: data},
            {
                timeout: 25000,
                button: button,
                spinner: jQuery('#spbc_settings_templates_export_button .spbc_preloader_button' ),
                callback: function(result, data, params, obj) {
                    let selector;
                    if (result.success) {
                        selector = '<p id=\'spbc-ajax-result\' class=\'success\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                        jQuery('#spbc_settings_templates_export_button .spbc_success').show(300);
                        setTimeout(function() {
                            jQuery('#spbc_settings_templates_export_button .spbc_success').hide(300);
                        }, 2000);
                        document.addEventListener('spbcModalClosed', function( e ) {
                            document.location.reload();
                        });
                        setTimeout(function() {
                            spbcModal.close();
                        }, 2000);
                    } else {
                        selector = '<p id=\'spbc-ajax-result\' class=\'error\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                    }
                },
            },
        );
    });

    // Reset settings
    jQuery( document ).on('click', '#spbc_settings_templates_reset_button', function() {
        let button = this;
        spbcSendAJAXRequest(
            {action: 'spbc_settings_templates_reset'},
            {
                timeout: 25000,
                button: button,
                spinner: jQuery('#spbc_settings_templates_reset_button .spbc_preloader_button' ),
                callback: function(result, data, params, obj) {
                    let selector;
                    if (result.success) {
                        selector = '<p id=\'spbc-ajax-result\' class=\'success\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                        jQuery('#spbc_settings_templates_reset_button .spbc_success').show(300);
                        setTimeout(function() {
                            jQuery('#spbc_settings_templates_reset_button .spbc_success').hide(300);
                        }, 2000);
                        document.addEventListener('spbcModalClosed', function( e ) {
                            document.location.reload();
                        });
                        setTimeout(function() {
                            spbcModal.close();
                        }, 2000);
                    } else {
                        selector = '<p id=\'spbc-ajax-result\' class=\'error\'>' + result.data + '</p>';
                        jQuery( selector ).insertAfter( jQuery(button) );
                    }
                },
            },
        );
    });

    jQuery(document).on('change', '#spbc_settings_templates_export', function() {
        let optionSelected = jQuery('option:selected', this);
        if ( optionSelected.data('id') === 'new_template' ) {
            jQuery(this).parent().parent().find('#spbc_settings_templates_export_name').show();
        } else {
            jQuery(this).parent().parent().find('#spbc_settings_templates_export_name').hide();
        }
    });

    //* TAB_CONTROL
    // migrated to react
    //* / REFRESH TAB IF ctrl+F5 END

    /**
     * Change cleantalk account email
     */
    jQuery(document).on('click', '#spbc-change-account-email', function(e) {
        e.preventDefault();

        let $this = jQuery(this);
        let accountEmailField = jQuery('#spbc-account-email');
        let accountEmail = accountEmailField.text();

        spbcToggleClass($this, 'active');

        if ($this.hasClass('active')) {
            $this.text($this.data('save-text'));
            accountEmailField.attr('contenteditable', 'true');
            accountEmailField.focus();
            accountEmailField.on('keydown', function(e) {
                if (e.code === 'Enter') {
                    e.preventDefault();
                }
            });
            accountEmailField.on('input', function(e) {
                if (e.inputType === 'insertParagraph') {
                    e.preventDefault();
                }
            });
        } else {
            spbcSendAJAXRequest(
                {
                    action: 'spbc_update_account_email',
                    accountEmail: accountEmail,
                },
                {
                    timeout: 5000,
                    callback: function(result, data, params, obj) {
                        if (result.success !== undefined && result.success === 'ok') {
                            if (result.manuallyLink !== undefined) {
                                jQuery('#spbc-key-manually-link').attr('href', result.manuallyLink);
                            }
                        }

                        if (result.error !== undefined) {
                            jQuery('#spbc-account-email').css('border-color', 'red');
                        }
                    },
                    errorOutput: function(msg) {
                        spbcModal.loaded = msg;
                        spbcModal.open();
                    },
                },
            );

            accountEmailField.attr('contenteditable', 'false');
            $this.text($this.data('default-text'));
        }
    });

    // Only handle legacy banners, not React Components
    // @ToDo remove the outdated way to close notice after transferring all tabs to components.
    jQuery(document).on('click', '.spbct_notice-dismiss', function(e) {
        let classListNotice = this.parentElement.classList;
        let classNoticeForClose = classListNotice[classListNotice.length - 1];

        document.querySelectorAll('.' + classNoticeForClose).forEach((element) => {
            element.parentElement.setAttribute('style', 'display:none;');
            spbcSetCookie(classNoticeForClose, 1, 86400 * 30);
        });
    });

    // @ToDo need to be refactored - this is the code dublication
    jQuery(document).off( 'click', '.spbc_long_description__show');
    jQuery(document).on('click', '.spbc_long_description__show', function() {
        self = jQuery(this);
        spbcHandleLongDescription(self, self.attr('data-setting') || self.attr('setting'));
    });

    // @ToDo need to be refactored - this is the code dublication
    jQuery(document).off( 'click', '.spbc_long_recommendation__show');
    jQuery(document).on('click', '.spbc_long_recommendation__show', function() {
        self = jQuery(this);
        spbcSettingsShowRecommendation(self, self.attr('data-setting') || self.attr('setting'));
    });
});

/**
 * Toggle class for DOM elements
 * @param {Array} arr
 * @param {string} className
 * @return {void}
 */
function spbcToggleClass(arr, className) {
    for (let i=0; i<arr.length; i++) {
        arr[i].classList.toggle(className);
    }
}

/**
 * Action to confirm creating support user.
 * @param {event} e
 * @return {void}
 */
function spbcCreateSupportUser(e) { // eslint-disable-line no-unused-vars
    e.preventDefault();
    let localTextArray = spbcSettings.support_user_creation_msg_array;
    spbcModal.open();
    spbcModal.confirm(
        localTextArray.confirm_header,
        localTextArray.confirm_text,
        '',
        spbcCreateUserCallback,
    );
}

/**
 * Support user creation callback.
 * @return {void}
 */
function spbcCreateUserCallback() {
    spbcSendAJAXRequest(
        {
            action: 'spbc_create_support_user',
        },
        {
            timeout: 5000,
            callback: function(result, data, params, obj) {
                let localTextArray = spbcSettings.support_user_creation_msg_array;
                let popupMsg = localTextArray.default_error;
                const responseValid = (
                    typeof result === 'object' &&
                    result.hasOwnProperty('success') &&
                    result.hasOwnProperty('user_created') &&
                    result.hasOwnProperty('mail_sent') &&
                    result.hasOwnProperty('cron_updated') &&
                    result.hasOwnProperty('user_data') &&
                    result.hasOwnProperty('result_code') &&
                    typeof result.user_data === 'object' &&
                    result.user_data.hasOwnProperty('username') &&
                    result.user_data.hasOwnProperty('email') &&
                    result.user_data.hasOwnProperty('password')
                );
                if (responseValid && result.success) {
                    if (result.user_created) {
                        let mailSentMsg = '';
                        let successCreationMsg = '';
                        let cronUpdatedMsg = localTextArray.cron_updated;

                        if (result.mail_sent) {
                            mailSentMsg = localTextArray.mail_sent_success;
                        } else {
                            mailSentMsg = localTextArray.mail_sent_error;
                        }

                        if (result.result_code === 0) {
                            successCreationMsg = localTextArray.user_updated;
                        } else {
                            successCreationMsg = localTextArray.user_created;
                        }

                        jQuery('#spbc_stats_user_creation_username').text(result.user_data.username);
                        jQuery('#spbc_stats_user_creation_email').text(result.user_data.email);
                        jQuery('#spbc_stats_user_creation_password').text(result.user_data.password);
                        jQuery('#spbc_stats_user_creation_mail_sent').text(mailSentMsg);
                        jQuery('#spbc_stats_user_creation_title').text(successCreationMsg);
                        jQuery('#spbc_stats_user_creation_cron_updated').text(cronUpdatedMsg);
                        jQuery('.spbc_stats_user_creation_result').css('display', 'block');
                        return;
                    } else {
                        if (result.result_code === -2) {
                            popupMsg = localTextArray.invalid_permission;
                        } else if (result.result_code === -1) {
                            popupMsg = localTextArray.unknown_creation_error;
                        } else if (result.result_code === -4) {
                            popupMsg = localTextArray.on_cooldown;
                        } else if (result.result_code === -5) {
                            popupMsg = localTextArray.email_is_busy;
                        }
                    }
                }
                spbcModal.loaded = popupMsg;
                spbcModal.open();
            },
            errorOutput: function(msg) {
                spbcModal.loaded = msg;
                spbcModal.open();
            },
        },
    );
}
